export class InnerDimension {
  name: string;
  id: string;
}
